import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-1/2 mx-auto" }
const _hoisted_2 = { class: "flex flex-col items-center gap-4 mb-8" }
const _hoisted_3 = { class: "text-xl leading-5 text-gray-600" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tipe Transaksi"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tambah Peserta")
], -1)
const _hoisted_5 = { class: "flex justify-between mb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Status", -1)
const _hoisted_7 = { class: "bg-green-500 rounded-full px-3 py-1 text-xs leading-5 text-white tracking-wide font-semibold" }
const _hoisted_8 = { class: "flex justify-between mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm leading-6 text-gray-400" }, "Tanggal", -1)
const _hoisted_10 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 border-gray-200" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invitation_summary = _resolveComponent("invitation-summary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.historyData.invoice_number), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.state.historyData.status), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatDateTime(_ctx.state.historyData.created_at)), 1)
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_invitation_summary, {
      data: _ctx.state.invitationData
    }, null, 8, ["data"])
  ]))
}